import React, { FC } from "react";
import { AnySessionPart, SessionPartKind } from "../session.types";
import { MDSSessionMarkdownV1Part } from "@/mds/components/sessions/session-parts/session-message-markdown-v1-part";
import { MDSSessionReasoningV1Part } from "@/mds/components/sessions/session-parts/session-message-reasoning-v1-part";
import { MDSSessionWebClipV1Part } from "@/mds/components/sessions/session-parts/session-message-web-clip-v1-part";
import { MDSSessionArtifactV1Part } from "@/mds/components/sessions/session-parts/artifacts/session-artifact-v1-part";
import { SessionPartContext } from "@/mds/components/sessions/session-parts/session-part.types";

interface Props {
  part: AnySessionPart;
  context: SessionPartContext;
}

export const MDSSessionPart: FC<Props> = ({ part, context }) => {
  switch (part.kind) {
    case SessionPartKind.MarkdownV1:
      return <MDSSessionMarkdownV1Part part={part} context={context} />;
    case SessionPartKind.ReasoningV1:
      return <MDSSessionReasoningV1Part part={part} context={context} />;
    case SessionPartKind.WebClipV1:
      return <MDSSessionWebClipV1Part part={part} context={context} />;
    case SessionPartKind.ArtifactV1:
      return <MDSSessionArtifactV1Part part={part} context={context} />;
    default:
      return null;
  }
};
